// src/store/userSlice.js
import { createSlice } from '@reduxjs/toolkit'

const userSlice = createSlice({
	name: 'user',
	initialState: {
		authUser: null, // { id, name, email }
		orgMemberships: [], // [ { orgId, orgSlug, orgName, role } ]
		currentOrg: null, // { orgId, orgSlug, orgName, role }
		currentExperience: null, // { id, slug, name, startDate, endDate }
	},
	reducers: {
		setAuthUser: (state, action) => {
			state.authUser = action.payload
		},
		setOrgMemberships: (state, action) => {
			state.orgMemberships = action.payload
		},
		setCurrentOrg: (state, action) => {
			state.currentOrg = action.payload
		},
		setCurrentExperience: (state, action) => {
			state.currentExperience = action.payload
		},
		resetUserState: () => ({
			authUser: null,
			orgMemberships: [],
			currentOrg: null,
			currentExperience: null,
		}),
	},
})

export const {
	setAuthUser,
	setOrgMemberships,
	setCurrentOrg,
	setCurrentExperience,
	resetUserState,
} = userSlice.actions

export default userSlice.reducer
